// Bounded in-memory piece store. Only for small files when OPFS is unavailable; never the universal strategy.
import { TransferFailure, MESSAGES } from '../errors.js';

export const DEFAULT_MEMORY_LIMIT = 48 * 1024 * 1024;

export function createMemoryStore(manifest, { limitBytes = DEFAULT_MEMORY_LIMIT } = {}) {
  if (manifest.sizeBytes > limitBytes) throw new TransferFailure('storage', MESSAGES.storage);
  const pieces = new Map();
  let held = 0;
  return {
    kind: 'memory',
    resumable: false,
    async open() { return []; },
    async put(index, bytes) {
      if (pieces.has(index)) return;
      if (held + bytes.length > limitBytes) throw new TransferFailure('storage', MESSAGES.storage);
      pieces.set(index, bytes); held += bytes.length;
    },
    async get(index) { return pieces.get(index) || null; },
    async drop(index) { const b = pieces.get(index); if (b) { held -= b.length; pieces.delete(index); } },
    async complete() {},
    async blob(mime) {
      const parts = [];
      for (let i = 0; i < manifest.pieces.length; i++) {
        const b = pieces.get(i);
        if (!b) throw new TransferFailure('file-integrity', MESSAGES['file-integrity']);
        parts.push(b);
      }
      return new Blob(parts, { type: mime || manifest.mime });
    },
    async remove() { pieces.clear(); held = 0; },
    release() {},
    heldBytes: () => held,
  };
}
